<template>
  <div class="content-container">
    <div class="search-table-layout">
      <a-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <!-- 搜索 -->
        <a-col :span="10">
          <a-form-model-item
            class="search-work-style"
            :label="$t('form.common.field.workName.label')"
            prop="name"
          >
            <a-input
              v-model="searchParam.name"
              :placeholder="$t('form.common.field.workName.message')"
            />
            <a-button
              type="primary"
              style="margin-left: 15px"
              @click="search"
              >{{ $t(`actionTitles.search`) }}</a-button
            >
          </a-form-model-item>
        </a-col>
        <!-- 按鈕 -->
        <a-col :span="12" :offset="2">
          <a-row class="btn-group-style">
            <a-button type="primary" @click="showUpModel" v-if="this.type == 5">{{
              $t(`actionTitles.addseats`)
            }}</a-button>
            <a-button type="primary" @click="showUpModel" v-else>{{
              $t(`actionTitles.uploadMaterial`)
            }}</a-button>
            <a-button
              v-if="folderDepthList.length<2"
              type="primary"
              :style="{ margin: '0px 15px' }"
              @click="addFloder"
              >{{ $t(`actionTitles.newFolder`) }}</a-button
            >
            <a-dropdown placement="bottomLeft">
              <a-menu
                slot="overlay"
                @click="handleChangeOperate"
                style="width: 120px"
              >
                <a-menu-item key="offlineDownload">{{
                  $t("actionTitles.offlineDownload")
                }}</a-menu-item>
                <a-menu-item key="delete">{{
                  $t("actionTitles.delete")
                }}</a-menu-item>
                <a-menu-item key="moveTo">{{
                  $t("actionTitles.moveTo")
                }}</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                {{ $t("actionTitles.moreOperate") }}
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </a-row>
        </a-col>
      </a-row>
<!-- 已選項 -->
      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />
       <!-- 根目錄 -->
      <a-row style="margin-bottom: 15px">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <a @click="queryByPid(0)">{{ $t("moduleTitles.root") }}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item
            v-for="(item, index) in folderDepthList"
            :key="index"
          >
            <a @click="queryByPid(item.id)">{{ item.name }}</a>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <!-- 目錄 -->
      <a-table
        :loading="loading"
        :data-source="dataSourse"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="pagination"
        :rowKey="rowKey"
        @change="handleTableChange"
      >
      <!-- 名稱 -->
        <a-table-column
          :title="$t('table.common.thead.materialName')"
          key="name"
          data-index="name"
          width="30%"
        >
          <template slot-scope="text, record">
            <div class="work-detail-layout">
              <div class="work-detail-img">
                <img
                  :src="record.url"
                  alt
                  style="width: 40px; height: 40px; cursor: pointer"
                  @click="perview(record)"
                  v-if="typeof record.dir_id === 'number' && record.type === 1"
                />
                <a-icon
                  type="audio"
                  theme="filled"
                  style="color: #1790ff; font-size: 40px"
                  @click="perview(record)"
                  v-else-if="
                    typeof record.dir_id === 'number' && record.type === 2
                  "
                />
                <a-icon
                  type="video-camera"
                  theme="filled"
                  style="color: #1790ff; font-size: 40px"
                  @click="perview(record)"
                  v-else-if="
                    typeof record.dir_id === 'number' && record.type === 3
                  "
                />
                <img
                  :src="record.cover"
                  alt
                  style="width: 40px; height: 40px; cursor: pointer"
                  @click="perview(record)"
                  v-else-if="record.cover && record.type === 4"
                />
                <img
                  :src="record.cover"
                  alt
                  style="width: 40px; height: 40px; cursor: pointer"
                  @click="perview(record)"
                  v-else-if="record.cover && record.type === 5"
                />
                <a-icon
                  type="folder"
                  theme="filled"
                  v-else
                  style="color: #1790ff; font-size: 40px"
                  @click="toFolder(record.id)"
                />
              </div>
              <div class="work-name-block">
                <template v-if="record.editable">
                  <a-input
                    style="margin: -5px 0"
                    :value="record.name ? record.name : record.filename"
                    @change="(e) => changeText(e.target.value, record)"
                  />
                </template>
                <template v-else>
                  <span
                    v-if="typeof record.dir_id != 'number'"
                    @click="record.name && toFolder(record.id)"
                    :class="[
                      record.name ? 'work-name-hover' : '',
                      'work-name-style',
                    ]"
                    >{{ record.name ? record.name : record.filename }}</span
                  >
                  <span
                    v-else
                    :class="[
                      record.name ? 'work-name-hover' : '',
                      'work-name-style',
                    ]"
                    @click="perview(record)"
                    >{{ record.name ? record.name : record.filename }}</span
                  >
                  <span class="work-name-remark" v-if="record.filesize">{{
                    record.filesize + "KB"
                  }}</span>
                  <span class="work-name-remark" v-if="typeof record.dir_id === 'number' && record.type === 5">直播地址：{{
                    record.url
                  }}</span>
                  <span class="work-name-remark" v-if="typeof record.dir_id === 'number' && record.type === 5">回放地址：{{
                    record.playback_url
                  }}</span>
                </template>
              </div>
            </div>
          </template>
        </a-table-column>
        <!-- 時間 -->
        <a-table-column
          :title="$t('table.common.thead.updateTime')"
          key="create_time"
          data-index="create_time"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.create_time ? record.create_time : "-" }}</span>
          </template>
        </a-table-column>
<!-- 狀態 -->
        <a-table-column
          v-if="userInfo.type == 3"
          :title="$t('table.common.thead.status')"
          key="status"
          data-index="status"
          align="center"
          width="20%"
        >
          <template slot-scope="text, record">
            <div v-if="typeof record.dir_id === 'number'">
              <span v-if="record.status === 0" style="color: #1890ff">{{
                $t("enum.materialAuditStatus.0")
              }}</span>
              <span v-else-if="record.status === 1" style="color: #43cf7c">{{
                $t("enum.materialAuditStatus.1")
              }}</span>
              <div class="status_refuse" v-else-if="record.status === 2">
                <span style="color: red">{{
                  $t("enum.materialAuditStatus.2")
                }}</span>
                <span style="font-size: 10px"
                  >{{ $t("descriptions.reason") }}: {{ record.reason }}</span
                >
              </div>
            </div>
          </template>
        </a-table-column>
<!-- 操作 -->
        <a-table-column
          :title="$t('table.common.thead.operate')"
          key="operate"
          data-index="operate"
          align="center"
        >
          <template slot-scope="text, record">
            <a href="javascript:;" @click="() => onReedit(record)" v-if="type==5">{{ $t(`actionTitles.edit`) }}</a>
            <a href="javascript:;" @click="() => onRename(record)" v-else>{{
              $t(`actionTitles.rename`)
            }}</a>
            <a-divider type="vertical" />
            <a-popconfirm
              :cancelText="$t('actionTitles.cancel')"
              :okText="$t('actionTitles.confirm')"
              :title="$t('message.softDeleteHint')"
              @confirm="() => onDelete(record)"
            >
              <a href="javascript:;" style="color: red">{{
                $t(`actionTitles.delete`)
              }}</a>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>

      <!--編輯彈窗 -->
      <a-modal
        :title="exitTitle"
        :visible="exitModel"
        @ok="save"
        @cancel="close"
        keyboard
      >
        <a-form-model
          ref="exitForm"
          :model="form"
          :rules="rules"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          :okText="$t('actionTitles.ascertain')"
          :cancelText="$t('actionTitles.cancel')"
        >
          <a-form-model-item ref="name" :label="$t('edit.name')" prop="name">
            <a-input
              v-model="form.name"
              :placeholder="$t('form.common.field.createFolder.placeholder')"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!-- 樹狀彈窗-->
      <a-modal
        v-model="treeVisible"
        :title="$t('actionTitles.moveTo')"
        :ok-text="$t('actionTitles.save')"
        :cancel-text="$t('actionTitles.cancel')"
        @ok="moveTo"
        keyboard
      >
        <a-directory-tree
          :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
          :load-data="onLoadData"
          :loadedKeys="loadedKeys"
          :tree-data="treeData"
          :selectedKeys="selectedKeys"
          @select="onSelect"
          ref="tree"
        />
      </a-modal>
    </div>
    <a-modal
      v-model="UpModelVisible"
      :title="$t('actionTitles.uploadMaterial')"
      @ok="saveUpFile"
      @cancel="cancelUpFile"
      v-if="this.type==1 || this.type==2 || this.type==3"
      keyboard
    >
      <DragUploader ref="uploader" :uptype="uptype"></DragUploader>
    </a-modal>

    <!--預覽素材彈窗-->
    <a-modal
      :title="$t('message.materialPreview')"
      :visible="materialPreviewModel"
      @cancel="previewClose"
      :footer="null"
      keyboard
    >
      <div style="margin-bottom: 20px; text-align: center">
        <img
          :src="previewItem.url"
          alt
          v-if="previewItem.type === 1"
          style="width: auto; max-width: 100%; display: inline-block"
        />
        <audio
          :src="previewItem.url"
          preload="none"
          controls="controls"
          v-else-if="previewItem.type === 2"
          style="width: 100%; margin-bottom: 24px"
        >
          {{ $t("message.audioFaileMessage") }}
        </audio>
        <video
          :src="previewItem.url"
          controls="controls"
          v-else-if="previewItem.type === 3 || previewItem.type === 4"
          height="100%"
          width="100%"
        >
          {{ $t("message.vedioFaileMessage") }}
        </video>
      </div>
    </a-modal>
    <!-- 直播上傳 -->
    <!-- title="增加機位" -->
    <a-modal
      :title="seatTitle"
      :visible="isLivePanoramicModel"
      @cancel="cancelUpFile"
      @ok="savelive"
      :destroyOnClose="true"
      v-if="this.type==5"
    >
    <upload-Panolive 
        ref="panoramiclive"
        :dir_id="dir_id"
        @refresh="loadData"
        @cancel="cancelUpFile"
        :form="form"
    ></upload-Panolive>
    </a-modal>
    <!-- 視頻上傳 -->
    <a-modal
      :title="$t('actionTitles.uploadePanramic')"
      :visible="isShowPanoramicModal"
      @cancel="cancelUpFile"
      @ok="savePanoramic"
      :destroyOnClose="true"
      v-if="this.type==4"
    >
      <upload-Panoramic
        ref="panoramic"
        :dir_id="dir_id"
        @refresh="loadData"
        @cancel="cancelUpFile"
      ></upload-Panoramic>
    </a-modal>
  </div>
</template>

<script>
import ClearSelected from "../../../../components/ClearSelected";
import {
  materialPageQuery,
  softDelete,
  regain,
  save,
  rename,
  getFolderDepth,
  querySub,
  moveDir,
  materialAdd,
} from "@/api/planeMaterial";
import DragUploader from "@/components/DragUploader";
import uploadPanoramic from "@/components/UploadPanoramic";
import UploadPanolive from "@/components/UploadPanolive";

import Vue from "vue";
import { downloadFile } from "@/utils/downloadFile.js";

import { mapState, mapGetters } from "vuex";
export default {
  name: "PageComponent",
  props: {
    type: {
      type: Number,
      require: true,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      loading: false,
      replace_id: 0, //要替換的場景id
      searchParam: {
        pid: 0,
        name: "",
        type: this.type,
        order: {},
      },
      form: {},
      columns: [
        {
          title: this.$t("table.common.thead.materialName"),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("table.common.thead.updateTime"),
          dataIndex: "create_time",
          key: "create_time",
          scopedSlots: { customRender: "create_time" },
          align: "center",
        },
        {
          title: this.$t("table.common.thead.status"),
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
          align: "center",
          width: "20%",
        },
        {
          title: this.$t("table.common.thead.operate"),
          dataIndex: "operate",
          key: "operate",
          scopedSlots: { customRender: "operate" },
          align: "center",
        },
      ],
      dataSourse: [],
      folderDepthList: [],
      editableItem: {},
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      exitModel: false,
      newFolderForm: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.common").field.createFolder.message,
            trigger: "blur",
          },
        ],
      },
      treeVisible: false,
      selectedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      folderDepthList: [],
      selectDirIds: [],
      UpModelVisible: false,
      exitTitle: "",
      seatTitle:"",
      loadedKeys: [],
      uptype: "",
      materialPreviewModel: false,
      previewItem: {},
      dir_id: 0,
      isShowPanoramicModal: false,
      isLivePanoramicModel: false,
      isLiverenameModel:false,
      moveLoading:false,
    };
  },
  components: { ClearSelected, DragUploader, uploadPanoramic,UploadPanolive },
  mounted() {
    this.loadData();
    if (this.type == 1) {
      this.uptype = "pic";
    } else if (this.type == 2) {
      this.uptype = "audio";
    } else if (this.type == 3) {
      this.uptype = "video";
    } else if (this.type == 4) {
      this.uptype = "cover";
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      materialPageQuery(this.searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.dataSourse = res.data.records;
            this.pagination.total = res.data.total;
            this.selectedRowKeys = [];
            this.selectedRows = [];
          }
        })
        .catch(() => {
          this.loading = false;
        });

      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    rowKey(record) {
      if (record.dir_id === undefined) {
        return "dir:" + record.id;
      } else {
        return record.id;
      }
    },
    perview(record) {
      if(this.type==5){
        return
      }
      this.previewItem = { ...record };
      this.materialPreviewModel = true;
    },
    previewClose() {
        this.previewItem = { ...{} };
        this.materialPreviewModel = false;
    },
    queryByPid(pid) {
      this.searchParam.pid = pid;
      this.pagination.current = 1;
      this.loadData();
    },
    addFloder() {
      this.form = { ...{} };
      this.exitTitle = this.$t("model.folder.addTitle");
      this.exitModel = true;
    },
    onDelete(record) {
      let delArr = [];
      let delInfo = { id: record.id };
      if (record.dir_id === undefined) {
        delInfo.type = "dir";
      } else {
        delInfo.type = "material";
      }
      delArr.push(delInfo);
      this.softDelete(delArr);
    },
    batchDelete() {
      let delArr = [];
      this.selectedRows.forEach((item) => {
        let delInfo = { id: item.id };
        if (item.dir_id === undefined) {
          delInfo.type = "dir";
        } else {
          delInfo.type = "material";
        }
        delArr.push(delInfo);
      });
      this.softDelete(delArr);
    },
    softDelete(delArr) {
      softDelete(delArr).then((res) => {
        this.$message.success(this.$t("message.deleteSuccess"));
        this.loadData();
      });
    },
    // 重命名
    onRename(record) {
      this.form = { ...record };
      this.exitTitle = this.$t("model.folder.renameTitle");
      this.exitModel = true;
    },
    // 編輯重命名
    onReedit(record) {
      if(record.dir_id == undefined){
        this.form = { ...record };
        this.exitTitle = this.$t("model.folder.renameTitle");
        this.exitModel= true;
      }else{
        this.form = { ...record };
        this.seatTitle =this.$t(`actionTitles.editing`);
        this.isLivePanoramicModel  = true;
      }
      
    },
    close() {
      this.exitModel = false;
      this.$refs.exitForm.resetFields();
    },
    save() {
      this.$refs.exitForm.validate((valid) => {
        if (valid) {
          this.form.type = this.type;
          this.form.pid = this.searchParam.pid;
          if (this.form.dir_id == undefined) {
            //文件夾
            save(this.form).then((res) => {
              this.$message.success(this.$t("message.saveSuccess"));
              this.exitModel = false;
              this.loadData();
            });
          } else {
            //素材
            rename(this.form).then((res) => {
              this.$message.success(this.$t("message.saveSuccess"));
              this.exitModel = false;
              this.loadData();
            });
          }
        }
      });
    },
    onCancel(id) {
      this.dataSourse.forEach((v, i) => {
        if (v.id === id) {
          Vue.set(this.dataSourse, i, {
            ...this.dataSourse[i],
            editable: false,
          });
        }
      });
      this.editableItem = {};
    },
    changeText(value, record) {
      if (typeof record.dir_id === "number") {
        this.editableItem = { ...record, filename: value };
      } else {
        this.editableItem = { ...record, name: value };
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.searchParam.current_page = pagination.current;
      if (sorter.order) {
        let order = sorter.order === "ascend" ? "asc" : "desc";
        this.searchParam.order[sorter.field] = order;
      } else {
        this.searchParam.order = {};
      }

      this.loadData();
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    toFolder(id) {
      this.searchParam.pid = id;
      //type
      this.pagination.current_page = 1;
      this.pagination.current = 1;
      this.loadData();
    },
    handleChangeOperate(e) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning(this.$t("message.selectHint"), 2);
      } else {
        if (e.key === "delete") {
          this.batchDelete();
        } else if (e.key === "offlineDownload") {
          this.selectedRows.map((v) => {
            if (typeof v.dir_id === "number") {
              downloadFile([v.url], v.name);
            }
          });
        } else if (e.key === "moveTo") {
          this.selectDirIds = [];
          this.selectedRows.map((v) => {
            if (v.dir_id === undefined) {
              this.selectDirIds.push(v.id);
            }
          });
          this.treeVisible = true;
          this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }];
          this.loadedKeys = [];
        }
      }
    },
    onLoadData(treeNode) {
      console.log(this.loadedKeys);

      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }else {
          setTimeout(() => {
            querySub({ pid: treeNode.dataRef.id, type: this.type }).then((res) => {
              if (res.code && res.data.length) {
                // 找出已選的資料夾ID
                let dir = [];
                this.selectedRows.forEach((item) => {
                  if (item.dir_id == undefined) {
                    dir.push(item.id);
                  }
                });
                // 清除自己所屬之資料夾
                let data = res.data.filter((item) => {
                  if (!dir.includes(item.id)) {
                    return item;
                  }
                });

                if(data.length) {
                  treeNode.dataRef.children = data
                }else{
                  treeNode.dataRef.isLeaf = true
                }
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            });
          }, 1);
        }
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    async moveTo() {
      if (!this.selectedKeys.length) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      if(this.moveLoading) return false
      this.moveLoading = true
      let dir = [];
      let pano = []
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dir.push(item.id);
        }else {
          pano.push(item.id);
        }
      });
      if(dir.length){
        //取得第二和第三層資料夾ID
        let target = this.treeData[0].children
        let allDeep3ID = []
        let allDeep2ID = []
        if(target){
          for(let i = 0;i<target.length;i++){
            allDeep2ID.push(target[i].id)
            if(target[i]?.children) {
              for(let j = 0;j<target[i].children.length;j++){
                allDeep3ID.push(target[i].children[j].id)
              }
            }
          }
        }
        //取得移動目標是否包含資料夾
        let payload = {
          current_page:1,
          name:'',
          order:{},
          per_page:10,
          pid:0,
          type:this.type
        }
        let hasDir = false
        for(let index = 0;index<dir.length;){
          payload.pid = dir[index]
          await materialPageQuery(payload)
            .then((res) => {
              if (res.code === 1) {
                hasDir = res.data.records.some((item)=> item.pid)
              }
            })
            .catch((error) => {
              console.log('error',error)
          });
          if(hasDir){
            break
          }else{
            // 延遲callAPI時間
            await new Promise(resolve => {
              setTimeout(() => {
                index++
                resolve()
              }, 200)
            });
          }
        }
        //當移動作品包括資料夾時，移動後不可超出三層資料夾
        if((allDeep3ID.includes(this.selectedKeys[0])) || (allDeep2ID.includes(this.selectedKeys[0]) && hasDir)) {
          this.$message.warning(this.$t("message.moveFail"))
          this.moveLoading = false
          return false
        }
      }
      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then((res) => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.loadData();
        this.moveLoading = false
      });
    },
    showUpModel() {
      this.dir_id = this.folderDepthList.length
        ? this.folderDepthList[this.folderDepthList.length - 1]["id"]
        : 0;
      this.replace_id = 0;
      switch(this.type){
        case 4:
          this.isShowPanoramicModal = true;
          break;
        case 5:
          this.isLivePanoramicModel = true;
          this.seatTitle = "增加機位";
          this.form = { ...{} };
          break;
        default :
          this.UpModelVisible = true
      }
    },
    cancelUpFile() {
      if (this.UpModelVisible) {
        this.UpModelVisible = false;
        this.$refs.uploader.delFile();
      } 
      else if(this.isShowPanoramicModal){
        this.isShowPanoramicModal = false;
        this.$refs.panoramic.init();
      }
      else if(this.isLivePanoramicModel){
        this.isLivePanoramicModel = false
        // this.$refs.panoramiclive.init();
      }
    },
    saveUpFile() {
      let _this = this;
      let list = this.$refs.uploader.fileList;
      if (this.$refs.uploader.completed == true && list.length > 0) {
        //組裝傳給服務端的數據
        let imgs = [];
        for (var i = 0; i < list.length; i++) {
          let tmp = {
            name: list[i].name,
            url: list[i].url,
            filesize: list[i].filesize,
            type: _this.type,
            dir_id: this.dir_id,
          };
          imgs.push(tmp);
        }
        this.cancelUpFile();
        this.loading = true;
        materialAdd(imgs).then((res) => {
          if (res.code == 1) {
            this.$message.success(this.$t("message.saveSuccess"));
            this.loadData();
          }
        });
      }
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },

    savePanoramic() {
      this.$refs.panoramic.savePanoramic();
    },
    savelive() {
      if(this.form.dir_id == undefined){
        this.$refs.panoramiclive.savePanoramic();
      }else{
        this.cancelUpFile();
      rename(this.form).then((res) => {
              this.$message.success(this.$t("message.saveSuccess"));
              this.exitModel = false;
              this.loadData();
            });
      }
      
    },
    }
}
</script>

<style lang="less" scoped>
.status_refuse {
  display: flex;
  flex-direction: column;
}
.specialBtn{
  background-color: #7101ad;
  border-color: #7101ad;
}
.renameTag {
  color: #d485ff;
}
</style>
